<template>
<div class="side animate-box">
    <h1><strong>On-Site Request Form</strong></h1>
    <hr />
	<br />
    <div v-if="returnmsg==''">        
        <h2>Employee Information</h2>
        <p> <span v-html="lang_detail['requiredDescription']"></span> (<span class="required_indicator">*</span>)</p>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="employer">Employer</label>
                <input type="text" id="employer" class="form-control" ref="employer" v-model="employer" aria-label="Employer" aria-required="true" @keypress="isLetterWithSpace($event)">
            </div>
            <span id="employer_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="name">Employee Name</label>
                <input type="text" id="name" class="form-control" ref="name" v-model="name" aria-label="Employee Name" aria-required="true" @keypress="isLetterWithSpace($event)">
            </div>
            <span id="name_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="address">Street Address</label>
                <input type="text" id="address" class="form-control" ref="address" v-model="address" aria-label="Street Address" aria-required="true" >
            </div>
            <span id="address_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="city">City</label>
                <input type="city" id="city" class="form-control" ref="city" v-model="city" aria-label="City" aria-required="true">
            </div>
            <span id="city_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="state">State</label>
                <select name="state" id="state" v-model="state" ref="state" class="form-control" aria-label="State">
                    <option value="" selected></option>
                    <option value="Alabama">Alabama</option>
                    <option value="Alaska">Alaska</option>
                    <option value="Arizona">Arizona</option>
                    <option value="Arkansas">Arkansas</option>
                    <option value="California">California</option>
                    <option value="Colorado">Colorado</option>
                    <option value="Connecticut">Connecticut</option>
                    <option value="Delaware">Delaware</option>
                    <option value="Florida">Florida</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Hawaii">Hawaii</option>
                    <option value="Idaho">Idaho</option>
                    <option value="Illinois">Illinois</option>
                    <option value="Indiana">Indiana</option>
                    <option value="Iowa">Iowa</option>
                    <option value="Kansas">Kansas</option>
                    <option value="Kentucky">Kentucky</option>
                    <option value="Louisiana">Louisiana</option>
                    <option value="Maine">Maine</option>
                    <option value="Maryland">Maryland</option>
                    <option value="Massachusetts">Massachusetts</option>
                    <option value="Michigan">Michigan</option>
                    <option value="Minnesota">Minnesota</option>
                    <option value="Mississippi">Mississippi</option>
                    <option value="Missouri">Missouri</option>
                    <option value="Montana">Montana</option>
                    <option value="Nebraska">Nebraska</option>
                    <option value="Nevada">Nevada</option>
                    <option value="New Hampshire">New Hampshire</option>
                    <option value="New Jersey">New Jersey</option>
                    <option value="New Mexico">New Mexico</option>
                    <option value="New York">New York</option>
                    <option value="North Carolina">North Carolina</option>
                    <option value="North Dakota">North Dakota</option>
                    <option value="Ohio">Ohio</option>
                    <option value="Oklahoma">Oklahoma</option>
                    <option value="Oregon">Oregon</option>
                    <option value="Pennsylvania">Pennsylvania</option>
                    <option value="Rhode Island">Rhode Island</option>
                    <option value="South Carolina">South Carolina</option>
                    <option value="South Dakota">South Dakota</option>
                    <option value="Tennessee">Tennessee</option>
                    <option value="Texas">Texas</option>
                    <option value="Utah">Utah</option>
                    <option value="Vermont">Vermont</option>
                    <option value="Virginia">Virginia</option>
                    <option value="Washington">Washington</option>
                    <option value="West Virginia">West Virginia</option>
                    <option value="Wisconsin">Wisconsin</option>
                    <option value="Wyoming">Wyoming</option>
                </select>            
            </div>
            <span id="state_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="zip">Zip</label>
                <input type="text" id="zip" class="form-control" ref="zip" v-model="zip" aria-label="Zipcode" aria-required="true">
            </div>
            <span id="zip_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <label for="home_phone">Home Phone</label>
                <input type="text" id="home_phone" class="form-control" ref="home_phone" v-model="home_phone" aria-label="Home Phone" aria-required="true">
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <label for="work_phone">Work Phone</label>
                <input type="text" id="work_phone" class="form-control" ref="work_phone" v-model="work_phone" aria-label="Home Phone" aria-required="true">
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <label for="best_phone">Best number &amp; time to follow-up if needed</label>
                <input type="text" id="best_phone" class="form-control" ref="best_phone" v-model="best_phone" aria-label="Best number and time to follow-up if needed" aria-required="true">
            </div>
        </div>
        <br />
        <h2>Literature Requests</h2>		
		<p>You may request up to 3.</p>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="The 36-Hour Day" aria-required="true" value="The 36-Hour Day" />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">The 36-Hour Day</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="The Relaxation and Stress Reduction Workbook" aria-required="true" value=" The Relaxation and Stress Reduction Workbook " />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">The Relaxation and Stress Reduction Workbook</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="The Grief Recovery Workbook" aria-required="true" value=" The Grief Recovery Workbook " />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">The Grief Recovery Workbook</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="How to Care for Aging Parents" aria-required="true" value=" How to Care for Aging Parents " />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">How to Care for Aging Parents</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="How to Retire Happy" aria-required="true" value=" How to Retire Happy " />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">How to Retire Happy</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="No-Drama Discipline" aria-required="true" value=" No-Drama Discipline " />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">No-Drama Discipline</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="Pocket Parent" aria-required="true" value=" Pocket Parent " />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">Pocket Parent</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="Stress-Free Potty Training" aria-required="true" value=" Stress-Free Potty Training " />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">Stress-Free Potty Training</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="College Rules! How to Study, Survive, and Succeed in College" aria-required="true" value=" College Rules! How to Study, Survive, and Succeed in College " />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">College Rules! How to Study, Survive, and Succeed in College</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="Get it Together for College & A Planner to Help You Get Organized and Get In" aria-required="true" value=" Get it Together for College & A Planner to Help You Get Organized and Get In " />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">Get it Together for College &ndash; A Planner to Help You Get Organized and Get In</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="What to Expect Baby-Sitter's Handbook" aria-required="true" value=" What to Expect Baby-Sitter's Handbook " />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">What to Expect Baby-Sitter's Handbook</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="What to Expect Pregnancy Journal &amp; Organizer" aria-required="true" value=" What to Expect Pregnancy Journal & Organizer " />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">What to Expect Pregnancy Journal &amp; Organizer</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="What to Expect When Expecting" aria-required="true" value=" What to Expect When Expecting " />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">What to Expect When Expecting</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="When You're Expecting Twins, Triplet or Quads" aria-required="true" value=" When You're Expecting Twins, Triplet or Quads " />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">When You're Expecting Twins, Triplet or Quads</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="What to Expect the First Year" aria-required="true" value=" What to Expect the First Year " />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">What to Expect the First Year</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="What to Expect the Second Year" aria-required="true" value=" What to Expect the Second Year " />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">What to Expect the Second Year</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="The Happiest Baby on the Block" aria-required="true" value=" The Happiest Baby on the Block " />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">The Happiest Baby on the Block</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-1">
                <input type="checkbox" class="form-control form-control-check" ref="request" v-model="request" aria-label="Seasonal Pack" aria-required="true" value=" Seasonal Pack " />
            </div>
            <div class="col-md-11">
                <label for="request" class="vrt">Seasonal Pack</label>
            </div>
        </div>
        <div class="row form-group">
            <p></p>
        </div>
        <div class="row form-group hhcap">
            <vue-hcaptcha :sitekey="$store.state.HC_SITE_KEY"  @verify="onVerify" @expired="onExpire" @error="onError"></vue-hcaptcha>
            <span id="hccaptcha_validation_error" role="alert"></span>
        </div>
        <div class="form-group">
            <button type="button" :disabled="disablefdbtn" class="btn submit btn-primary" @click="sendForm()" v-html="this.lang_detail['submit']"></button>
        </div>
    </div>
    <p v-else v-html="returnmsg" role="alert"></p>
</div>    
</template>

<script>
import axios from 'axios';
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';
export default {
    name: 'ContactTobaccofree',
    data(){
        return{
            lang_detail:[],request:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            languageData:this.$store.state.languageData,
            fterms:'',message:'',work_phone:'',name:'',returnmsg:'',employer:'',
            address:'',
            city:'',
            state:'',
            zip:'',
            home_phone:'',
            best_phone:'',
            verified: false,
            expired: false,
            token: null,
            eKey: null,
            error: null,
            disablefdbtn:false
        };
        
    },
    components:{
        VueHcaptcha       
    },
    mounted :function(){
        this.getlangVar()
    },
    watch: {
        employer: function() {
            this.validateFormRemoveMarkers('employer_validation_error');               
        },
        name: function() {
            this.validateFormRemoveMarkers('name_validation_error');               
        },
        address: function() {
            this.validateFormRemoveMarkers('address_validation_error');               
        },        
        city: function() {
            this.validateFormRemoveMarkers('city_validation_error');               
        },
        state: function() {
            this.validateFormRemoveMarkers('state_validation_error');               
        },
        zip: function() {
            this.validateFormRemoveMarkers('zip_validation_error');               
        },
        verified: function() {
            this.validateFormRemoveMarkers('hccaptcha_validation_error');               
        }
    },
	methods:{
        sendForm(){
            if(this.employer == ''){
                this.validateFormAddMarkers('employer_validation_error','dynamic_form_error_required','Employer field is required.');
                this.$refs.employer.focus(); 
                $('#employer_validation_error').attr('aria-label','Employer field is required');
                return false;
            } else if(this.address == ''){
                this.validateFormAddMarkers('address_validation_error','dynamic_form_error_required','Street Address field is required.');
                this.$refs.address.focus(); 
                $('#address_validation_error').attr('aria-label','Street Address field is required');
                return false;
            } else if(this.city == ''){
                this.validateFormAddMarkers('city_validation_error','dynamic_form_error_required','City field is required.');
                this.$refs.city.focus(); 
                $('#city_validation_error').attr('aria-label','City field is required');
                return false;
            } else if(this.state == ''){
                this.validateFormAddMarkers('state_validation_error','dynamic_form_error_required','State field is required.');
                this.$refs.state.focus(); 
                $('#state_validation_error').attr('aria-label','State field is required');
                return false;
            } else if(this.zip == ''){
                this.validateFormAddMarkers('zip_validation_error','dynamic_form_error_required','Zip field is required.');
                this.$refs.zip.focus(); 
                $('#zip_validation_error').attr('aria-label','Zip field is required');
                return false;
            }
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'                   
                }
            }

            const formData = new FormData()
            formData.append('employer', this.employer)
            formData.append('name', this.name)
            formData.append('address', this.address)
            formData.append('city', this.city)
            formData.append('state', this.state)
            formData.append('zip', this.zip)
            formData.append('home_phone', this.home_phone)
            formData.append('work_phone', this.work_phone)
            formData.append('best_phone', this.best_phone)
            formData.append('request', this.request)
            formData.append('id_company', this.$store.state.companyData['id_company'])
            formData.append('id_language', this.$store.state.companyData['id_language'])
            formData.append('name_company', this.$store.state.companyData['name_company'])
            formData.append('id_eap', this.$store.state.companyData['id_eap'])
            formData.append('id_country', this.$store.state.companyData['id_country'])
            formData.append('hc_token', this.token)
            var validateForm = this.validateForm(this.name,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,this.verified);           
            if(!validateForm){
                this.disablefdbtn=true;
                axios.post(this.$store.state.FORM_ACTION_DOMAIN+'/new_eesite_forms/lit_request_form.php',formData,config)
                .then(response => {
                    if(response === undefined || response.length == 0 ){
                        this.returnmsg='! Something went wrong, Please try again'
                    }
                    else{
                        this.returnmsg = response.data                        
                    }
                })
                .catch(() => {
                    this.returnmsg='Try after sometime'
                });
            }
        },
        getlangVar(){
            var api_private_key=this.get_api_key_mix('lams')
            axios.get(this.$store.state.apiUrl+'/language_terms',{
                params:{
                    id_language:this.$store.state.companyData['id_language'],
                    privatekey:api_private_key,
                    id_company:this.$store.state.companyData['id_company'],
                    id_country:this.$store.state.companyData['id_country']                  
                }
            })
            .then(response => {              
                response = response.data;
                this.lang_detail = response;
                var titleValue ="On-Site Request Form";                
                var home = this.lang_detail['d00'];
                this.$announcer.set(this.decodeHtmlLang(titleValue)+' | '+this.$store.state.companyData['name_company']);
                document.title = this.decodeHtmlLang(titleValue)+' | '+this.$store.state.companyData['name_company'];                
            })
            .catch(() => {
                this.main_content = []
            });
        },
        onVerify(token, ekey) {
            this.verified = true;
            this.token = token;
            this.eKey = ekey;
        },
        onExpire() {
            this.verified = false;
            this.token = null;
            this.eKey = null;
            this.expired = true;
            console.log('hcExpired');
        },
        onError(err) {
            this.token = null;
            this.eKey = null;
            this.error = err;
            console.log(`hcError: ${err}`);
        }

    }
};
</script>
<style scoped>
.form-group{
    margin-bottom: 40px;
}
.dynamic_form_error_required{
    padding-left:15px !important;
    color:#FF0000 !important;    
}
.required_indicator {
    font-family: Verdana;
    font-size: 14px;
    color: red;
}
.form-control {
    -webkit-appearance: auto;
    -moz-appearance: auto;
    appearance: auto;    
}
.form-control-check{
    width: 20px;
}
.hhcap{
    padding-left: 1em;
}
.vrt{
    vertical-align: middle;
    padding-top:17px;
}

@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .col-md-1{
        width: 10% !important;
    }
    .col-md-11{
        width: 90% !important;
    }
}
</style>